import {useQuery} from "@tanstack/react-query";
import {readTaxEndDate} from "../../../../../api/order/DeadlineApi";

export const useReadTaxEndDate = () => {
    const {data} = useQuery({
        queryKey: ["readTaxEndDate"],
        queryFn: async () => await readTaxEndDate(),
        select: (res) => res?.data.result ?? null,
    });

    return {data};
};
